import Timer from '_tradeholding/js/Classes/Timer.js';

import jQuery from 'jquery';
import Mustache from 'mustache';
import config from '_config';

import '_tradeholding/scss/components/notifications.scss';

if (typeof config.notifications == 'undefined') config.notifications = {};
config.notificatons = jQuery.merge(config.notifications, {
    timer: 85000
});

class TH_NotificationBox {
    constructor(templates) {
        this.dom = {
            main: null
        };

        this.templates = templates;


        this.runId = null;
    }

    init() {
        let selfRef = this;

        this.dom.main = jQuery("tradeholding-notifications");
        this.defaults = this.dom.main.data('defaults');

        if (this.dom.main.find('th-notification:not(.tradeholding-shown)').length > 0) {
            setTimeout(function() {
                selfRef.showNotifications();
            }, 1000);
        }
    }

    /** Checks if the set type is a valid type or not
     * 
     */
    isValidType(type) {
        console.log(this.defaults);
        if (jQuery.inArray(type, this.defaults.validTypes) == -1) return false;
        else return true;
    }

    /** Get the default icon for the notification based on a type
     * 
     * @param string type (the type to get the notification icon for)
     * 
     * @return string (returns a string as an icon)
     */
    getDefaultIcon(type) {
        return this.defaults.defaultIcons[type];
    }

    /** Get the default title for the notification based on a type
     * 
     * @param string type (the type to get the notification title for)
     * 
     * @return string (returns a string as the title)
     */
    getDefaultTypeTitle(type) {
        return this.defaults.defaultTitles[type];
    }

    /** Create a new notification and show it on the page
     * 
     * @param string        type       (the type of the notification to show, must be one of the valid notification type strings, ie: 'error', 'success', etc.)
     * @param string|jQuery message    (the content of the notification, either a simple string object, or a more complex jQuery object)
     * @param string        icon       (a string that contains a valid font-awesome icon class, ie: fa-exclamation-circle, you can ommit the fa part, if empty, the 
     *                                  default type icon will be used based on the type parameter provided)
     * @parma string        typeTitle  (a string that contains the title to use for the notification, if ommited or empty, the default notification title based on the
     *                                  type provided will be used)
     * 
     * @returns jQuery (returns the jquery object of the created notification)
     */
    createNotification(type, message, icon, typeTitle) {
        let notificationTemplate = this.templates.notification,
            notification,
            selfRef = this;

        if (typeof type == 'undefined' || !this.isValidType(type)) {
            return console.error("The type you provided is not a valid notification type!");
        }

        if (typeof message == 'undefined') {
            return console.error("Provide a valid message for the notification!");
        } else if (message instanceof jQuery) message = message.prop('outerHTML');

        if (typeof icon == 'undefined' || icon === null) icon = this.getDefaultIcon(type);
        if (typeof typeTitle == 'undefined' || typeTitle === null) typeTitle = this.getDefaultTypeTitle(type);


        notification = Mustache.render(notificationTemplate, {
            content: message,
            type: type,
            icon: icon,
            typeTitle: typeTitle
        });

        notification = jQuery(notification);


        this.dom.main.prepend(jQuery(notification));
        notification.hide().show(0, function() {
            selfRef.showNotifications();
        });        
    }

    showNotifications(runId) {
        let notification = this.dom.main.find('th-notification:not(.tradeholding-shown)').last(),
            selfRef = this,
            transitionCounter = 0;
            

        if (typeof runId === 'undefined') {
            if (this.runId !== null) return;
            else {
                this.runId = utils.default.guid();
                runId = this.runId;
            }
        } else if (this.runId !== runId) return;

        notification.addClass('tradeholding-shown');
        notification.data('timer', new Timer(function() {
            notification.addClass('tradeholding-destroy');
            notification.one('animationEnd webkitAnimationEnd msAnimationEnd oAnimationEnd', function(e) {
                notification.remove();
            });
        }, config.notifications.timer));
        
        if (notification.hasClass('tradeholding-paused')) {
            notification.data('timer').pause();
        }

        if (selfRef.dom.main.find('th-notification:not(.tradeholding-shown)').length > 0) {
            setTimeout(function() {
                selfRef.showNotifications(runId);
            }, 150);
        } else selfRef.runId = null;

        notification.one('animationEnd webkitAnimationEnd msAnimationEnd oAnimationEnd', function(e) {
            let closer = notification.find('.notification-close i');

            if (closer.length == 0) closer = notification;
            closer.on('click', function() {
                let list = notification.nextAll().addBack();

                list.addClass('tradeholding-destroy');
                list.one('animationEnd webkitAnimationEnd msAnimationEnd oAnimationEnd', function(e) {
                    jQuery(e.currentTarget).remove();
                });

            });
            
            notification.on('mouseenter', function(e) {
                notification.data('timer').pause();
                notification.addClass('tradeholding-paused');
                notification.prevAll().each(function() {
                    let notTimer = jQuery(this).data('timer');
    
                    if (notTimer != null) notTimer.pause();
                    jQuery(this).addClass('tradeholding-paused');
                });
            });
    
            
            notification.on('mouseleave', function() {
                notification.data('timer').resume();
                notification.removeClass('tradeholding-paused');
                notification.prevAll().each(function() {
                    let notTimer = jQuery(this).data('timer');
    
                    if (notTimer != null) notTimer.resume();
                    jQuery(this).removeClass('tradeholding-paused');
                });
            });
        });
        
        return notification;
    }
}

export default TH_NotificationBox;


